import { tracker } from 'app-components/utils/core';
import useQPreferences from 'components/QPreferences/useQPreferences';

const useSetThemeKey = () => {
  const { setDatasetPreference } = useQPreferences();

  return (themeKey: 'muiDefault' | 'ACME_DARK' | 'system-appearance') => {
    tracker.track(tracker.events.appearance, { themeKey });
    setDatasetPreference({ theme: themeKey });
  };
};

export default useSetThemeKey;
